import {callApi} from "./api";
import * as contract from "../contract";

// The business dashboard (see contract/metrics.ts). Only the people the server lists may ask; anyone else gets a 403.
export const getDashboardQuery = async (days: number) =>
    (await callApi(contract.metrics.getDashboard, { query: { days: String(days) as `${typeof contract.metrics.DASHBOARD_DAYS[number]}` } })).dashboard;
